<div
  class="iss-avatar"
  [class.iss-avatar--active]="active"
  [class.iss-avatar--colored]="color"
  [style.background-color]="bgColor"
  [style.background-image]="bgImage"
  [style.color]="color"
>
  <ng-container *ngIf="hasInitials">
    {{ username | avatarInitials }}
  </ng-container>
  <iss-icon class="iss-avatar-icon" *ngIf="icon && hasIcon" [name]="icon"/>
  <ng-content/>
</div>
